import qs from 'qs'

const YOUTUBE_API_URL = 'https://www.googleapis.com/youtube/v3'

const api = (endpoint, method = 'GET', params = {}, body = {}) => {
  const init = {}

  let authMethod = method
  if (method === 'POST' && typeof body['method'] !== 'undefined') {
    authMethod = body.method
  }
  init.method = authMethod

  if (authMethod !== 'GET' && Object.keys(body).length !== 0) {
    init.body = new FormData()
    for (const key in body) {
      init.body.append(key, body[key])
    }
  }

  return fetch(`${YOUTUBE_API_URL}${endpoint}?${qs.stringify(params)}`, init)
}

export default api
